import { defineStore } from 'pinia';
import { defaultToPrint, defaultEconomicPerformanceToPrint } from '../Helpers/transportModes';

export const useTransportModes = defineStore('componentStore', {
    id: 'components',
    state: () => ({
        //profile
        components: JSON.parse(localStorage.getItem('customHeaderComponents')),
        componentsForPrint: defaultToPrint,
        currentComponent: null,
        // economic performance
        componentsEconomicPerformance: JSON.parse(localStorage.getItem('customHeaderEconomicPerformanceComponents')),
        componentsEconomicPerformanceForPrint: defaultEconomicPerformanceToPrint,
        currentEconomicPerformanceComponent: null
    }),
    getters: {
        //profile
        getComponents(state) {
            return state.components
        },
        // economic performance
        getComponentsEconomicPerformance(state) {
            return state.componentsEconomicPerformance
        },
    },
    actions: {
        //profile
        updateComponents(components) {

            if (components) {
                this.components = components;

                localStorage.setItem('customHeaderComponents', JSON.stringify(components));
            } else {
                console.warn('Attempted to update components with an invalid value:', components);
            }
        },
        updateComponentsToPrint(components) {

            if (components) {
                this.componentsForPrint = components;
            } else {
                console.warn('Attempted to update components with an invalid value:', components);
            }
        },
        getCurrentComponente(component) {
            this.currentComponent = component
        },
        // economic performance
        updateComponentsEconomicPerformance(components) {

            if (components) {
                this.componentsEconomicPerformance = components;

                localStorage.setItem('customHeaderEconomicPerformanceComponents', JSON.stringify(components));
            } else {
                console.warn('Attempted to update components with an invalid value:', components);
            }
        },
        updateComponentsEconomicPerformanceToPrint(components) {

            if (components) {
                this.componentsEconomicPerformanceForPrint = components;
            } else {
                console.warn('Attempted to update components with an invalid value:', components);
            }
        },
        getCurrentComponentsEconomicPerformance(component) {
            this.currentEconomicPerformanceComponent = component
        },
    },
});
